import type { MediaPlanConfigBehavior } from '../media-plan-config-registry';
import { normalizeMetaAdAccountId } from 'shared/src/meta/meta-types';

// Meta is always the split form: one campaign (+ ad set) per objective row on the card. The
// prompt names the proposeMeta input fields; everything else on a Meta campaign / ad set is a
// server-side constant, so the card pins only what the trader actually chooses.
export const metaConfigBehavior: MediaPlanConfigBehavior = {
  buildProposePrompt: s => {
    const rows = s.campaigns ?? [];
    return [
      'The user has finalized the configuration in the workspace card. Create one Meta campaign ' +
        '(+ one ad set) per entry below: call proposeMeta ONCE with a `campaigns` array, then call ' +
        'createMetaMediaPlan with the resolved proposal it returns. budget_share is ' +
        'price-denominated; the server converts it to the media budget (margin removed) and sets ' +
        'each campaign’s lifetime budget from it. Use exactly these values:',
      `- account_id=${normalizeMetaAdAccountId(s.accountId ?? '')}`,
      `- page_id=${s.pageId ?? ''}`,
      s.specialAdCategories && s.specialAdCategories.length > 0
        ? `- special_ad_categories=${s.specialAdCategories.join(', ')}`
        : '- special_ad_categories=(none)',
      s.ageMin !== undefined ? `- age_min=${s.ageMin}` : '- age_min=(default)',
      s.geo && s.geo.length > 0
        ? `- geo_targets=${s.geo.join('; ')}`
        : '- geo_targets=(none on the card — structure them from the Zoho Geo Targets in context; ' +
          'a national buy is "United States")',
      ...rows.map((c, i) => {
        const parts = [
          `objective=${c.objective}`,
          ...(c.performanceGoal ? [`performance_goal=${c.performanceGoal}`] : []),
          `budget_share=${c.budgetShare}`,
          `name suffix=${c.name ?? '(none)'}`
        ];
        return `- campaign ${i + 1}: ${parts.join('; ')}`;
      }),
      'Campaign and ad set names are derived server-side; set campaign_payload.name ONLY to the ' +
        'name suffix shown (omit it when "(none)"), omit ad_set_payload.name, and omit ' +
        'ad_set_payload dates so they default to the execution line item flight.'
    ].join('\n');
  }
};
